export default __webpack_public_path__ + "static/media/hero-bg-1.60c61795.webp";